import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TableRow,
    Table,
    TableHead,
    TableBody,
    TableCell,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Card,
    Box,
    TableContainer,
    Paper,
    Typography,
    Grid,
    TextField,
    IconButton,
    InputAdornment,
    Tooltip,
    Chip,
    FormHelperText,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    CircularProgress,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import TeacherService from "./Locality/Service/teacherService";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SchoolIcon from '@material-ui/icons/School';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Divider } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";

const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: { padding: theme.spacing(1) },
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#0f2d4d',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#6b7280',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    primaryBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#eef4ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1769d6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
    },
    filtersHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
        backgroundColor: '#fafbfc',
    },
    filtersBody: {
        padding: theme.spacing(2),
    },
    filterLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
    },
    iconBtnOutlined: {
        border: '1px solid #e6eaf0',
        borderRadius: 8,
        padding: 7,
    },
    headCell: {
        backgroundColor: '#f4f6fa',
        color: '#46566b',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #e6eaf0',
        whiteSpace: 'nowrap',
    },
    classChip: {
        backgroundColor: '#eef4ff',
        color: '#1769d6',
        fontWeight: 600,
        height: 24,
    },
    sectionChip: {
        backgroundColor: '#f3efff',
        color: '#7c4dff',
        fontWeight: 600,
        height: 24,
    },
    statusActive: {
        backgroundColor: '#e6f7ed',
        color: '#1a9b54',
        fontWeight: 600,
        height: 24,
    },
    statusInactive: {
        backgroundColor: '#f4f6fa',
        color: '#9aa6b6',
        fontWeight: 600,
        height: 24,
    },
    tableStatusFooter: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid #eef1f5',
        backgroundColor: '#fafbfc',
    },
    addressExpandRow: {
        backgroundColor: '#f8fafc',
        '& td': {
            borderBottom: '1px solid #e6eaf0',
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
        },
    },
    addressExpandBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 10,
        border: '1px solid #e6eaf0',
        backgroundColor: '#fff',
    },
    teacherDetailGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: theme.spacing(2),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    teacherDetailItem: {
        minWidth: 0,
    },
    teacherDetailLabel: {
        fontSize: '0.72rem',
        fontWeight: 700,
        color: '#9aa6b6',
        textTransform: 'uppercase',
        marginBottom: 4,
        letterSpacing: '0.04em',
    },
    teacherDetailValue: {
        color: '#0f2d4d',
        fontSize: '0.9rem',
        lineHeight: 1.5,
        wordBreak: 'break-word',
    },
    assignClassCell: {
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    statusCountLabel: {
        fontSize: '0.8125rem',
        color: '#46566b',
        fontWeight: 600,
    },
    actionBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        fontSize: '0.75rem',
        padding: '4px 10px',
        minWidth: 0,
    },
    assignBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        border: 'none',
        minWidth: 132,
        justifyContent: 'center',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    transferBtn: {
        borderColor: '#1769d6',
        color: '#1769d6',
    },
    iconAction: {
        padding: 6,
        color: '#46566b',
        '&:hover': { backgroundColor: '#f1f5fb', color: '#1769d6' },
    },
    deleteIcon: {
        padding: 6,
        color: '#46566b',
        '&:hover': { backgroundColor: '#ffebee', color: '#c62828' },
    },
    dialogPaper: {
        borderRadius: 14,
        maxWidth: 340,
        width: '100%',
        margin: theme.spacing(2),
    },
    dialogPaperWide: {
        borderRadius: 14,
        maxWidth: 640,
        width: '95%',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
        backgroundColor: '#fafafa',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2, 2.5, 1.5),
    },
    infoBox: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5),
        backgroundColor: '#eef4ff',
        borderRadius: 10,
        border: '1px solid #d6e4ff',
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    sectionLabel: {
        display: 'block',
        fontWeight: 700,
        color: '#46566b',
        fontSize: '0.72rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: theme.spacing(1.25),
    },
    formSection: {
        marginBottom: theme.spacing(1.5),
    },
    formGrid: {
        width: '100%',
        margin: 0,
    },
    formGridItem: {
        paddingTop: `${theme.spacing(1)}px !important`,
        paddingBottom: `${theme.spacing(1)}px !important`,
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
        backgroundColor: '#fafafa',
        gap: theme.spacing(1),
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    assignListWrap: {
        maxHeight: 420,
        overflowY: 'auto',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        backgroundColor: '#fafbfc',
    },
    assignClassBlock: {
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
        '&:last-child': { borderBottom: 'none' },
    },
    assignClassTitle: {
        fontWeight: 700,
        color: '#0f2d4d',
        fontSize: '0.95rem',
        marginBottom: 4,
    },
    assignSectionRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        paddingLeft: theme.spacing(1),
    },
    primaryClassBox: {
        padding: theme.spacing(1.5, 2),
        borderRadius: 10,
        backgroundColor: '#f0f7ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    dialogPaperTransfer: {
        borderRadius: 14,
        maxWidth: 480,
        width: '95%',
        margin: theme.spacing(2),
    },
    transferTeacherList: {
        maxHeight: 320,
        overflowY: 'auto',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        backgroundColor: '#fafbfc',
    },
    transferTeacherRow: {
        padding: theme.spacing(1, 1.5),
        borderBottom: '1px solid #eef1f5',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        '&:last-child': { borderBottom: 'none' },
        '&:hover': { backgroundColor: '#f1f5fb' },
    },
    transferTeacherRowSelected: {
        backgroundColor: '#eef4ff',
        '&:hover': { backgroundColor: '#e8f0fe' },
    },
    transferAssignedBox: {
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        backgroundColor: '#f8fafc',
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    transferAssignedChip: {
        margin: theme.spacing(0.25),
        backgroundColor: '#eef4ff',
        color: '#0f2d4d',
        fontWeight: 600,
    },
}));

const isTeacherActive = (teacher) =>
    teacher.status === 'active' || teacher.status === true || teacher.status == null;

const teacherHasPrimaryClass = (teacher) => {
    if (!teacher?.classId) return false;
    if (typeof teacher.classId === 'object') return Boolean(teacher.classId._id);
    return String(teacher.classId).trim() !== '';
};

const hasAdditionalClassAssignments = (teacher) =>
    Array.isArray(teacher?.additionalClassAndSection) &&
    teacher.additionalClassAndSection.length > 0;

const teacherHasAnyAssignedClass = (teacher) =>
    teacherHasPrimaryClass(teacher) || hasAdditionalClassAssignments(teacher);

/** Collect primary + additional classes for transfer UI (deduped by classId). */
const getTeacherAssignedClasses = (teacher) => {
    const rows = [];
    const seen = new Set();

    const pushRow = ({ classId, className, sectionName, isPrimary }) => {
        const id = String(classId || '').trim();
        if (!id || seen.has(id)) return;
        seen.add(id);
        rows.push({
            classId: id,
            className: className || 'Class',
            sectionName: sectionName || '',
            isPrimary: Boolean(isPrimary),
        });
    };

    if (teacher?.classId) {
        pushRow({
            classId: teacher.classId._id || teacher.classId,
            className: teacher.classId?.className || '',
            sectionName: teacher.sectionId?.sectionName || '',
            isPrimary: true,
        });
    }

    (teacher?.additionalClassAndSection || []).forEach((entry) => {
        const classId = entry?.class?.classId?._id || entry?.class?.classId;
        const sections = Array.isArray(entry?.sectionId) ? entry.sectionId : [];
        const sectionName = sections
            .map((s) => s?.sectionName)
            .filter(Boolean)
            .join(', ');
        pushRow({
            classId,
            className: entry?.class?.className || '',
            sectionName,
            isPrimary: false,
        });
    });

    return rows;
};

const normalizeRefId = (value) => {
    if (value == null || value === '') return '';
    if (typeof value === 'object') return String(value._id || value.sectionId || value.classId || '');
    return String(value);
};

/**
 * True when the teacher already holds this class/section:
 * - same primary class + same section (or both with no section)
 * - same class in additionalClassAndSection with that section, or whole-class (no sections)
 */
const teacherAlreadyHasClassSection = (teacher, classId, sectionId) => {
    const targetClassId = normalizeRefId(classId);
    if (!teacher || !targetClassId) return false;
    const targetSectionId = normalizeRefId(sectionId);

    const primaryClassId = normalizeRefId(teacher.classId?._id || teacher.classId);
    if (primaryClassId && primaryClassId === targetClassId) {
        const primarySectionId = normalizeRefId(teacher.sectionId?._id || teacher.sectionId);
        if (!targetSectionId && !primarySectionId) return true;
        if (targetSectionId && primarySectionId && targetSectionId === primarySectionId) return true;
    }

    return (teacher.additionalClassAndSection || []).some((entry) => {
        const entryClassId = normalizeRefId(entry?.class?.classId?._id || entry?.class?.classId);
        if (entryClassId !== targetClassId) return false;
        const sections = Array.isArray(entry?.sectionId) ? entry.sectionId : [];
        if (sections.length === 0) {
            // Whole-class additional assignment covers any section (and no-section).
            return true;
        }
        if (!targetSectionId) {
            // Transferring class-wide access; already has this class with section(s).
            return true;
        }
        return sections.some(
            (s) => normalizeRefId(s?.sectionId?._id || s?.sectionId || s?._id) === targetSectionId,
        );
    });
};

const getTransferSectionIdForClass = (fromTeacher, classId) => {
    const targetClassId = normalizeRefId(classId);
    if (!fromTeacher || !targetClassId) return '';

    const primaryClassId = normalizeRefId(fromTeacher.classId?._id || fromTeacher.classId);
    if (primaryClassId === targetClassId) {
        return normalizeRefId(fromTeacher.sectionId?._id || fromTeacher.sectionId);
    }

    const additional = (fromTeacher.additionalClassAndSection || []).find(
        (entry) => normalizeRefId(entry?.class?.classId?._id || entry?.class?.classId) === targetClassId,
    );
    const sections = Array.isArray(additional?.sectionId) ? additional.sectionId : [];
    if (sections.length === 1) {
        return normalizeRefId(sections[0]?.sectionId?._id || sections[0]?.sectionId || sections[0]?._id);
    }
    return '';
};

export default function Teacher() {
    const classes = useStyles();
    const userDetails = useMemo(
        () => JSON.parse(localStorage.getItem("userDetail") || "{}"),
        []
    );
    const isSchoolAdmin = userDetails.role === 'SCHOOLE';
    const tableHeaders = useMemo(() => {
        const headers = ['Teacher Name', 'Class', 'Section', 'View', 'Status', 'Assign Class', 'Actions', 'Transfer'];
        if (isSchoolAdmin) headers.push('Reset Password');
        return headers;
    }, [isSchoolAdmin]);
    const [teacherList, setTeacherList] = useState([]);
    const [age, setAge] = React.useState('');
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [teacher, setTeacher] = useState({
        teacherName: '',
         email: '',
        password: '',
        qualification: '',
        address: '',
        mobileNumber: '',
        classId: '',
        sectionId: '',
        status: 'active',
    })
    
               var [searchClassId, setSearchClassId] = useState("");
    
     const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [transferOpen, setTransferOpen] = useState(false);
    const [transferFromTeacher, setTransferFromTeacher] = useState(null);
    const [transferClassId, setTransferClassId] = useState('');
    const [transferToTeacherId, setTransferToTeacherId] = useState('');
    const [transferTeacherSearch, setTransferTeacherSearch] = useState('');
    const [transferSaving, setTransferSaving] = useState(false);
    const [transferCandidateList, setTransferCandidateList] = useState([]);
    const [transferCandidatesLoading, setTransferCandidatesLoading] = useState(false);
    // State for assigning multiple classes/sections to a teacher
    const [assignOpen, setAssignOpen] = useState(false);
    const [assignTeacher, setAssignTeacher] = useState(null);
    const [assignSectionsByClass, setAssignSectionsByClass] = useState({});
    const [assignSelections, setAssignSelections] = useState({});
    const [assignSectionsLoading, setAssignSectionsLoading] = useState(false);
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
    const [resetPasswordTeacher, setResetPasswordTeacher] = useState(null);
    const [resetPasswordValue, setResetPasswordValue] = useState('');
    const [resetPasswordError, setResetPasswordError] = useState('');
    const [resetPasswordSuccess, setResetPasswordSuccess] = useState('');
    const [resetPasswordSaving, setResetPasswordSaving] = useState(false);
    const [resetShowPassword, setResetShowPassword] = useState(false);
    const [expandedAddressId, setExpandedAddressId] = useState(null);
    const [noteOpen, setNoteOpen] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [pg, setPg] = useState(0);
    const [rpg, setRpg] = useState(10);
    const validationSchema = Yup.object().shape({
        teacherName: Yup.string().required('Teacher name is required'),
        classId: Yup.string(),
        email: Yup.string(),
        password: Yup.string().when('_id', {
            is: (val) => !!val,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.required('Password is required'),
        }),
        qualification: Yup.string(),
        address: Yup.string(),
        status: Yup.string()
            .oneOf(['active', 'inactive'], 'Status must be Active or Inactive')
            .required('Status is required'),
        mobileNumber: Yup.string().required('Mobile number is required')
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(10, 'Must be exactly 10 digits')
            .max(10, 'Must be exactly 10 digits'),
    });
    const fetchFilteredTeachers = useCallback(() => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!userDetails.schooleId) return;

        if (searchClassId) {
            TeacherService.findTeachertList({ classId: searchClassId }).then((res) => {
                const mapResult = res.map((teacher) => ({ ...teacher }));
                setTeacherList(mapResult);
            }).catch(() => {});
        } else {
            TeacherService.getAllTeacher(userDetails.schooleId).then((res) => {
                const mapResult = res.map((teacher) => ({ ...teacher }));
                setTeacherList(mapResult);
            }).catch(() => {});
        }
    }, [searchClassId]);

    useEffect(() => {
        setPg(0);
        fetchFilteredTeachers();
    }, [fetchFilteredTeachers]);

    useEffect(() => {
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setTeacher({
                teacherName: '',
                 email: '',
                password: '',
                qualification: '',
                address: '',
                mobileNumber: '',
                classId: '',
                status: 'active',
            })
        }

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => {
                // de-duplicate by className just in case
                const list = Array.isArray(res) ? res : [];
                const map = new Map();
                for (const item of list) {
                    const key = String(item?.className || "").trim().toLowerCase();
                    if (!key) continue;
                    if (!map.has(key)) map.set(key, item);
                }
                const unique = Array.from(map.values()).sort((a, b) =>
                    String(a?.className || "").localeCompare(String(b?.className || ""))
                );
                setAddClassList(unique);
            })
            .catch(() => {
                setAddClassList([]);
            });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };
    const getPrimaryClassId = (teacher) => {
        if (!teacher?.classId) return '';
        return String(teacher.classId._id || teacher.classId);
    };

    const getPrimarySectionId = (teacher) => {
        if (!teacher?.sectionId) return '';
        return String(teacher.sectionId._id || teacher.sectionId);
    };

    /** Sections that can be added as additional (excludes the teacher's primary section). */
    const getAssignableSections = (teacher, classId, sections) => {
        const list = Array.isArray(sections) ? sections : [];
        const primaryClassId = getPrimaryClassId(teacher);
        const primarySectionId = getPrimarySectionId(teacher);
        if (!primaryClassId || String(classId) !== primaryClassId || !primarySectionId) {
            return list;
        }
        return list.filter((s) => String(s._id) !== primarySectionId);
    };

    const loadAssignSectionsForAllClasses = (classes) => {
        const schooleId = userDetails.schooleId;
        if (!schooleId || !Array.isArray(classes) || classes.length === 0) {
            setAssignSectionsByClass({});
            setAssignSectionsLoading(false);
            return Promise.resolve({});
        }
        setAssignSectionsLoading(true);
        return Promise.all(
            classes.map((cls) =>
                SectionService.findSectionList({
                    schooleId,
                    classId: cls._id,
                })
                    .then((res) => ({ classId: cls._id, sections: Array.isArray(res) ? res : [] }))
                    .catch(() => ({ classId: cls._id, sections: [] }))
            )
        ).then((rows) => {
            const map = {};
            rows.forEach(({ classId, sections }) => {
                map[classId] = sections;
            });
            setAssignSectionsByClass(map);
            return map;
        }).finally(() => setAssignSectionsLoading(false));
    };

    const buildAssignSelectionsFromAssignments = (items) => {
        const selections = {};
        (items || []).forEach((item) => {
            const classId = item?.class?.classId;
            if (!classId) return;
            selections[String(classId)] = (item.sectionId || [])
                .map((s) => String(s.sectionId || s._id || ''))
                .filter(Boolean);
        });
        return selections;
    };

    const buildAssignmentsFromSelections = (selections, sectionsByClass) => {
        return Object.entries(selections || {}).map(([classId, sectionIds]) => {
            const selectedClass = addClassList.find((c) => String(c._id) === String(classId));
            const sections = sectionsByClass[classId] || [];
            const ids = Array.isArray(sectionIds) ? sectionIds : [];
            return {
                class: {
                    classId,
                    className: selectedClass?.className || '',
                },
                sectionId: ids.map((id) => {
                    const sec = sections.find((s) => String(s._id) === String(id));
                    return {
                        sectionId: id,
                        sectionName: sec?.sectionName || '',
                    };
                }),
            };
        });
    };

    const isClassFullySelected = (classId, sections) => {
        const selected = assignSelections[String(classId)];
        if (selected === undefined) return false;
        if (!sections || sections.length === 0) return true;
        return sections.length > 0 && sections.every((s) => selected.includes(String(s._id)));
    };

    const isClassPartiallySelected = (classId, sections) => {
        const selected = assignSelections[String(classId)];
        if (!selected || !sections || sections.length === 0) return false;
        const count = sections.filter((s) => selected.includes(String(s._id))).length;
        return count > 0 && count < sections.length;
    };

    const toggleAssignClass = (classId, sections) => {
        const key = String(classId);
        setAssignSelections((prev) => {
            const next = { ...prev };
            if (!sections || sections.length === 0) {
                if (next[key] !== undefined) delete next[key];
                else next[key] = [];
                return next;
            }
            const current = next[key] || [];
            const allSelected =
                sections.length > 0 &&
                sections.every((s) => current.includes(String(s._id)));
            if (allSelected) {
                delete next[key];
            } else {
                next[key] = sections.map((s) => String(s._id));
            }
            return next;
        });
    };

    const toggleAssignSection = (classId, sectionId) => {
        const key = String(classId);
        const sid = String(sectionId);
        setAssignSelections((prev) => {
            const current = Array.isArray(prev[key]) ? [...prev[key]] : [];
            const idx = current.indexOf(sid);
            if (idx >= 0) {
                current.splice(idx, 1);
            } else {
                current.push(sid);
            }
            const next = { ...prev };
            if (current.length === 0) delete next[key];
            else next[key] = current;
            return next;
        });
    };
    // const getStudentList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     StudentService.getAllStudent(userDetails.schooleId).then((res) => {
    //      const mapResult =   res.map((student)=>{
    //             return {...student,fullName:`${student.firstName} ${student.lastName} `}
    //         })
    //         setStudentList(mapResult);
    //     }).catch((err) => {
    //         console.error("Error fetching student list:", err);
    //     });
    // };
    const editTeacher = (rowTeacher) => {
        const teacherForForm = {
            ...rowTeacher,
            classId: rowTeacher.classId ? (rowTeacher.classId._id || rowTeacher.classId) : '',
            sectionId: rowTeacher.sectionId ? (rowTeacher.sectionId._id || rowTeacher.sectionId) : '',
            status: (rowTeacher.status === true || rowTeacher.status === 'active') ? 'active' : 'inactive',
        };
        if (teacherForForm.classId) {
            getSectionListByClass(teacherForForm.classId);
        } else {
            setSectionList([]);
        }
        setTeacher(teacherForForm);
        handleOpen(false);
        setIsEditMode(true);
    }
    const deleteTeacher = (teacherdelete) => {
        if (teacherdelete) {
            const teacherName = teacherdelete.teacherName || 'this teacher';
            const confirmMessage = `Are you sure you want to delete "${teacherName}"?\n\nThis action cannot be undone. All associated data will be permanently removed.`;
            
            if (window.confirm(confirmMessage)) {
                TeacherService.deleteTeacher(teacherdelete).then((res) => {
                    fetchFilteredTeachers();
                    alert(`Teacher "${teacherName}" has been deleted successfully.`);
                }).catch((err) => {
                    alert(err?.response?.data?.message || `Failed to delete teacher "${teacherName}". Please try again.`);
                });
            }
        }
    };

    const openResetPasswordDialog = (rowTeacher) => {
        if (!rowTeacher?._id) return;
        setResetPasswordTeacher(rowTeacher);
        setResetPasswordValue('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
        setResetPasswordOpen(true);
    };

    const closeResetPasswordDialog = () => {
        setResetPasswordOpen(false);
        setResetPasswordTeacher(null);
        setResetPasswordValue('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
    };

    const handleResetPasswordSubmit = () => {
        if (!resetPasswordTeacher?._id) return;

        const password = resetPasswordValue.trim();
        if (password.length < 6) {
            setResetPasswordError('Password must be at least 6 characters.');
            return;
        }

        setResetPasswordSaving(true);
        setResetPasswordError('');
        TeacherService.resetTeacherPassword(resetPasswordTeacher._id, { password })
            .then((res) => {
                const teacherName = resetPasswordTeacher.teacherName || 'Teacher';
                setResetPasswordSuccess(
                    res?.data?.message || `Password updated successfully for "${teacherName}".`
                );
            })
            .catch((err) => {
                setResetPasswordError(
                    err?.response?.data?.message || 'Failed to reset password. Please try again.'
                );
            })
            .finally(() => setResetPasswordSaving(false));
    };

    // ----- Assign Class & Section (additionalClassAndSection) -----
    const openAssignClassDialog = (rowTeacher) => {
        const existing = Array.isArray(rowTeacher.additionalClassAndSection)
            ? rowTeacher.additionalClassAndSection
            : [];

        const normalizedAssignments = existing.map((item) => {
            const cls = item && item.class ? item.class : {};
            const classId =
                (cls.classId && cls.classId._id) ||
                cls.classId ||
                (cls._id || "");
            const className = cls.className || (cls.classId && cls.classId.className) || "";

            const sections = Array.isArray(item.sectionId)
                ? item.sectionId.map((sec) => {
                    const sectionId =
                        (sec && sec.sectionId && sec.sectionId._id) ||
                        (sec && sec.sectionId) ||
                        (sec && sec._id) ||
                        "";
                    const sectionName =
                        (sec && sec.sectionName) ||
                        (sec && sec.sectionId && sec.sectionId.sectionName) ||
                        "";
                    return {
                        sectionId,
                        sectionName,
                    };
                  }).filter((s) => s.sectionId)
                : [];

            return {
                class: {
                    classId,
                    className,
                },
                sectionId: sections,
            };
        });

        setAssignTeacher(rowTeacher);
        setAssignSelections(buildAssignSelectionsFromAssignments(normalizedAssignments));
        setAssignSectionsByClass({});
        setAssignOpen(true);
        loadAssignSectionsForAllClasses(addClassList);
    };

    const handleAssignClose = () => {
        setAssignOpen(false);
        setAssignTeacher(null);
        setAssignSectionsByClass({});
        setAssignSelections({});
        setAssignSectionsLoading(false);
    };

    const handleAssignSave = () => {
        if (!assignTeacher) {
            return;
        }
        const primaryClassId = getPrimaryClassId(assignTeacher);
        const primarySectionId = getPrimarySectionId(assignTeacher);
        const selections = { ...assignSelections };

        // Primary section stays on Teacher.sectionId — keep only other sections
        // of the primary class under additionalClassAndSection.
        if (primaryClassId && Array.isArray(selections[primaryClassId])) {
            const withoutPrimarySection = primarySectionId
                ? selections[primaryClassId].filter((id) => String(id) !== primarySectionId)
                : selections[primaryClassId];
            if (withoutPrimarySection.length === 0) {
                delete selections[primaryClassId];
            } else {
                selections[primaryClassId] = withoutPrimarySection;
            }
        }

        const assignments = buildAssignmentsFromSelections(selections, assignSectionsByClass);
        TeacherService.updateAdditionalClassAndSection(assignTeacher._id, {
            additionalClassAndSection: assignments,
        })
            .then((res) => {
                handleAssignClose();
                fetchFilteredTeachers();
                alert(res?.data?.message || res?.message || "Additional classes/sections updated successfully.");
            })
            .catch((err) => {
                alert(
                    err?.response?.data?.message ||
                    "Failed to update additional classes/sections."
                );
            });
    };

    const openTransferPopup = (rowTeacher) => {
        const assigned = getTeacherAssignedClasses(rowTeacher);
        if (assigned.length === 0) return;

        const preferredClassId =
            getPrimaryClassId(rowTeacher) || assigned[0].classId;

        setTransferFromTeacher(rowTeacher);
        setTransferClassId(preferredClassId);
        setTransferToTeacherId('');
        setTransferTeacherSearch('');
        setTransferCandidateList([]);
        setTransferOpen(true);
        setTransferCandidatesLoading(true);

        // Always load the full school roster so unassigned (new) teachers appear
        // even when the table is filtered by class.
        const schoolId = userDetails.schooleId;
        if (!schoolId) {
            setTransferCandidatesLoading(false);
            return;
        }
        TeacherService.getAllTeacher(schoolId)
            .then((res) => {
                const list = Array.isArray(res) ? res : (res?.data || []);
                setTransferCandidateList(list.map((teacher) => ({ ...teacher })));
            })
            .catch(() => {
                setTransferCandidateList([]);
            })
            .finally(() => {
                setTransferCandidatesLoading(false);
            });
    };

    const handleTransferClose = () => {
        setTransferOpen(false);
        setTransferFromTeacher(null);
        setTransferClassId('');
        setTransferToTeacherId('');
        setTransferTeacherSearch('');
        setTransferSaving(false);
        setTransferCandidateList([]);
        setTransferCandidatesLoading(false);
    };

    const handleTransferSubmit = () => {
        if (!transferToTeacherId || !transferFromTeacher || !transferClassId || transferSaving) return;

        setTransferSaving(true);
        TeacherService.transferTeacher({
            fromTeacherId: transferFromTeacher._id,
            toTeacherId: transferToTeacherId,
            classId: transferClassId,
        }).then((res) => {
            handleTransferClose();
            fetchFilteredTeachers();
            alert(res?.message || res?.data?.message || 'Transfer completed successfully.');
        }).catch((err) => {
            alert(err?.response?.data?.message || 'Failed to transfer teacher data.');
        }).finally(() => {
            setTransferSaving(false);
        });
    };

    const transferAssignedClasses = useMemo(
        () => getTeacherAssignedClasses(transferFromTeacher),
        [transferFromTeacher],
    );

    // Transfer targets: active teachers with a class AND new teachers with no class.
    const teachersForTransfer = useMemo(() => {
        const fromId = transferFromTeacher?._id;
        return transferCandidateList
            .filter((t) => {
                if (fromId && t._id === fromId) return false;
                return isTeacherActive(t);
            })
            .sort((a, b) => {
                // Unassigned (new) teachers first, then by name.
                const aHas = teacherHasPrimaryClass(a) ? 1 : 0;
                const bHas = teacherHasPrimaryClass(b) ? 1 : 0;
                if (aHas !== bHas) return aHas - bHas;
                return (a.teacherName || '').localeCompare(b.teacherName || '');
            });
    }, [transferCandidateList, transferFromTeacher]);

    const transferWithoutClassCount = useMemo(
        () => teachersForTransfer.filter((t) => !teacherHasPrimaryClass(t)).length,
        [teachersForTransfer],
    );

    const filteredTeachersForTransfer = useMemo(() => {
        const term = transferTeacherSearch.trim().toLowerCase();
        if (!term) return teachersForTransfer;
        return teachersForTransfer.filter((t) => {
            const name = (t.teacherName || '').toLowerCase();
            const mobile = String(t.mobileNumber || '').toLowerCase();
            const email = (t.email || '').toLowerCase();
            const className = (t.classId?.className || '').toLowerCase();
            const sectionName = (t.sectionId?.sectionName || '').toLowerCase();
            return (
                name.includes(term)
                || mobile.includes(term)
                || email.includes(term)
                || className.includes(term)
                || sectionName.includes(term)
            );
        });
    }, [teachersForTransfer, transferTeacherSearch]);

    const handleResetFilters = () => {
        setSearchClassId('');
        setSearchTerm('');
        setPg(0);
    };

    const toggleViewAddress = (id) => {
        setExpandedAddressId((prev) => (prev === id ? null : id));
    };

    const filteredList = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return teacherList;
        return teacherList.filter((row) => {
            const name = (row.teacherName || '').toLowerCase();
            const cls = (row.classId?.className || '').toLowerCase();
            const sec = (row.sectionId?.sectionName || '').toLowerCase();
            const addr = (row.address || '').toLowerCase();
            return name.includes(term) || cls.includes(term) || sec.includes(term) || addr.includes(term);
        });
    }, [teacherList, searchTerm]);

    const activeTeacherCount = useMemo(
        () => filteredList.filter(isTeacherActive).length,
        [filteredList]
    );
    const inactiveTeacherCount = useMemo(
        () => filteredList.length - activeTeacherCount,
        [filteredList, activeTeacherCount]
    );

    const formik = useFormik({
        initialValues: teacher,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            const isInactive = values.status === 'inactive';
            
            // Show warning alert if status is Inactive
            if (isInactive) {
                const confirmMessage = teacher._id 
                    ? "Warning: Setting teacher status to Inactive will deactivate their login credentials (mobile number and password). They will not be able to log in. Do you want to continue?"
                    : "Warning: Creating teacher with Inactive status means their login credentials (mobile number and password) will be deactivated. They will not be able to log in. Do you want to continue?";
                
                if (!window.confirm(confirmMessage)) {
                    return; // User cancelled, don't submit
                }
            }
            
            const payload = {
                ...values,
                schooleId: userDetails.schooleId,
                status: values.status === 'active',
                classId: values.classId || null,
                sectionId: values.sectionId || null,
            };
            if (teacher._id) {
                payload._id = teacher._id;
                delete payload.password;
                TeacherService.upadeTeacher(payload).then((res) => {
                    handleClose();
                    fetchFilteredTeachers();
                    resetForm();
                    if (isInactive) {
                        alert("Teacher Updated Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Updated Successfully.");
                    }
                }).catch((err) => {
                    alert(err?.response?.data?.message || err?.response?.data?.error || "Failed to update teacher.");
                });
            }
            else {
                TeacherService.creteTeacher(payload).then((res) => {
                    fetchFilteredTeachers();
                    resetForm();
                    handleClose();
                    if (isInactive) {
                        alert("Teacher Added Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Added Successfully.");
                    }
                })
                    .catch((err) => {
                        alert(err?.response?.data?.message || "Failed to add teacher.");
                    });
            }
        },
    });

    return (
        <Box className={classes.pageWrapper}>
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Teacher</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Manage teachers, assign classes and sections, and transfer class ownership between teachers.
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    className={classes.primaryBtn}
                    startIcon={<AddIcon />}
                    onClick={() => handleOpen(true)}
                >
                    Add Teacher
                </Button>
            </Box>

            {noteOpen && (
                <Box className={classes.noteBanner}>
                    <Box className={classes.noteIconWrap}>
                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                    </Box>
                    <Box flex={1}>
                        <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
                            Assign Class &amp; Transfer
                        </Typography>
                        <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2, lineHeight: 1.6 }}>
                            <strong>Assign Class</strong> gives a teacher access to additional class/section combinations.
                            <strong> Transfer</strong> moves all assigned classes (primary and additional) from one teacher to another active teacher —
                            including newly created teachers with no class yet, and teachers who already have a class (their current class is kept as an additional assignment).
                            {isSchoolAdmin && (
                                <>
                                    {' '}
                                    <strong>Reset Password</strong> lets you set a new login password for a teacher who forgot it or cannot sign in — enter the new password and share it with the teacher so they can log in to the Teacher app with their mobile number.
                                </>
                            )}
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setNoteOpen(false)}>
                        <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
            )}

            <Card elevation={0} className={classes.filtersCard}>
                <Box className={classes.filtersHeader}>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                        <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>
                            Filters
                        </Typography>
                        {searchClassId && (
                            <Chip size="small" label="Class selected" style={{ backgroundColor: '#eef4ff', color: '#1769d6', fontWeight: 600, height: 22 }} />
                        )}
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <Button size="small" className={classes.resetBtn} onClick={handleResetFilters}>
                            Reset
                        </Button>
                    </Box>
                </Box>
                <Box className={classes.filtersBody}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Typography className={classes.filterLabel}>
                                <SchoolIcon style={{ fontSize: 16, color: '#1769d6' }} />
                                Class
                            </Typography>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <InputLabel id="filter-class-label">All Classes</InputLabel>
                                <Select
                                    labelId="filter-class-label"
                                    name="searchClassId"
                                    label="All Classes"
                                    value={searchClassId}
                                    onChange={(e) => setSearchClassId(e.target.value)}
                                >
                                    <MenuItem value=""><em>All Classes</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Card>

            <Card elevation={0} className={classes.tableCard}>
                <Box className={classes.toolbar}>
                    <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                        {activeTeacherCount} Active Teacher{activeTeacherCount !== 1 ? 's' : ''}
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search teachers…"
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setPg(0); }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} size="small" onClick={fetchFilteredTeachers}>
                                <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                    <Table stickyHeader size="small" className="dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                {tableHeaders.map((key) => (
                                    <TableCell key={key} className={classes.headCell}>
                                        {key === 'Reset Password' ? (
                                            <Tooltip
                                                title="Set a new login password when a teacher forgot it or cannot access the Teacher app. Click the key icon in each row."
                                                arrow
                                            >
                                                <span style={{ cursor: 'help', borderBottom: '1px dotted #9aa6b6' }}>
                                                    {key}
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            key
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredList.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={tableHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                        No teachers found.
                                    </TableCell>
                                </TableRow>
                            )}
                            {filteredList.slice(pg * rpg, pg * rpg + rpg).flatMap((row) => {
                                const isExpanded = expandedAddressId === row._id;
                                return [
                                    <TableRow key={row._id} hover>
                                        <TableCell>
                                            <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.875rem' }}>
                                                {row.teacherName || '—'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {row.classId?.className ? (
                                                <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={row.classId.className} className={classes.classChip} />
                                            ) : '—'}
                                        </TableCell>
                                        <TableCell>
                                            {row.sectionId?.sectionName ? (
                                                <Chip size="small" label={row.sectionId.sectionName} className={classes.sectionChip} />
                                            ) : '—'}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={isExpanded ? 'Hide details' : 'View details'}>
                                                <IconButton
                                                    className={classes.iconAction}
                                                    size="small"
                                                    onClick={() => toggleViewAddress(row._id)}
                                                >
                                                    {isExpanded ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={isTeacherActive(row) ? 'Active' : 'Inactive'}
                                                className={isTeacherActive(row) ? classes.statusActive : classes.statusInactive}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.assignClassCell}>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                className={`${classes.actionBtn} ${classes.assignBtn}`}
                                                startIcon={<AssignmentIndIcon style={{ fontSize: 16 }} />}
                                                onClick={() => openAssignClassDialog(row)}
                                            >
                                                {hasAdditionalClassAssignments(row) ? 'Edit Assign' : 'Assign Class'}
                                            </Button>
                                        </TableCell>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" justifyContent="flex-start" style={{ gap: 4 }}>
                                                <Tooltip title="Edit">
                                                    <IconButton className={classes.iconAction} size="small" onClick={() => editTeacher(row)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete">
                                                    <IconButton className={classes.deleteIcon} size="small" onClick={() => deleteTeacher(row)}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            {teacherHasAnyAssignedClass(row) && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    className={`${classes.actionBtn} ${classes.transferBtn}`}
                                                    startIcon={<SwapHorizIcon style={{ fontSize: 16 }} />}
                                                    onClick={() => openTransferPopup(row)}
                                                >
                                                    Transfer
                                                </Button>
                                            )}
                                        </TableCell>
                                        {isSchoolAdmin && (
                                            <TableCell>
                                                <Tooltip title="Reset teacher login password">
                                                    <IconButton
                                                        className={classes.iconAction}
                                                        size="small"
                                                        onClick={() => openResetPasswordDialog(row)}
                                                    >
                                                        <VpnKeyIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>,
                                    isExpanded ? (
                                        <TableRow key={`${row._id}-address`} className={classes.addressExpandRow}>
                                            <TableCell colSpan={tableHeaders.length}>
                                                <Box className={classes.addressExpandBox}>
                                                    <Box style={{ width: '100%' }}>
                                                        <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: '#9aa6b6', textTransform: 'uppercase', marginBottom: 12, letterSpacing: '0.04em' }}>
                                                            Teacher details · {row.teacherName || 'Teacher'}
                                                        </Typography>
                                                        <Box className={classes.teacherDetailGrid}>
                                                            <Box className={classes.teacherDetailItem}>
                                                                <Typography className={classes.teacherDetailLabel}>Mobile number</Typography>
                                                                <Typography className={classes.teacherDetailValue}>
                                                                    {row.mobileNumber?.trim() || '—'}
                                                                </Typography>
                                                            </Box>
                                                            <Box className={classes.teacherDetailItem}>
                                                                <Typography className={classes.teacherDetailLabel}>Email</Typography>
                                                                <Typography className={classes.teacherDetailValue}>
                                                                    {row.email?.trim() || '—'}
                                                                </Typography>
                                                            </Box>
                                                            <Box className={classes.teacherDetailItem}>
                                                                <Typography className={classes.teacherDetailLabel}>Qualification</Typography>
                                                                <Typography className={classes.teacherDetailValue}>
                                                                    {row.qualification?.trim() || '—'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box display="flex" alignItems="flex-start" style={{ gap: 12 }}>
                                                            <LocationOnIcon style={{ color: '#1769d6', marginTop: 2, flexShrink: 0 }} />
                                                            <Box>
                                                                <Typography className={classes.teacherDetailLabel}>Address</Typography>
                                                                <Typography className={classes.teacherDetailValue} style={{ whiteSpace: 'pre-wrap' }}>
                                                                    {row.address?.trim() || 'No address recorded.'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ) : null,
                                ].filter(Boolean);
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredList.length}
                    page={pg}
                    onPageChange={(_, p) => setPg(p)}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={(e) => { setRpg(parseInt(e.target.value, 10)); setPg(0); }}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                />

                <Box className={classes.tableStatusFooter}>
                    <Typography className={classes.statusCountLabel}>Status summary:</Typography>
                    <Chip
                        size="small"
                        label={`Active: ${activeTeacherCount}`}
                        className={classes.statusActive}
                    />
                    <Chip
                        size="small"
                        label={`Inactive: ${inactiveTeacherCount}`}
                        className={classes.statusInactive}
                    />
                    <Typography className={classes.statusCountLabel} style={{ marginLeft: 'auto', color: '#9aa6b6' }}>
                        Total shown: {filteredList.length}
                    </Typography>
                </Box>
            </Card>

            <Dialog open={open} onClose={handleClose} scroll="paper" fullWidth maxWidth="xs" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {teacher._id ? 'Edit Teacher' : 'Add Teacher'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                    <DialogContent className={classes.dialogBody}>
                        <Box className={classes.formSection}>
                            <span className={classes.sectionLabel}>Teacher Information</span>
                            <Grid container spacing={1} className={classes.formGrid}>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Teacher Name</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoFocus
                                        autoComplete="off"
                                        id="teacherName"
                                        name="teacherName"
                                        type="text"
                                        value={formik.values.teacherName}
                                        onChange={formik.handleChange}
                                        error={formik.touched.teacherName && Boolean(formik.errors.teacherName)}
                                        helperText={formik.touched.teacherName && formik.errors.teacherName}
                                    />
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Email ID</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Mobile Number</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="mobileNumber"
                                        name="mobileNumber"
                                        type="text"
                                        inputProps={{ maxLength: 10 }}
                                        value={formik.values.mobileNumber}
                                        onChange={formik.handleChange}
                                        error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                        helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                                    />
                                </Grid>
                                {!teacher._id && (
                                    <Grid item xs={12} className={classes.formGridItem}>
                                        <span className={classes.fieldLabel}>Set Password</span>
                                        <TextField
                                            fullWidth size="small" variant="outlined"
                                            autoComplete="new-password"
                                            id="password"
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            error={formik.touched.password && Boolean(formik.errors.password)}
                                            helperText={formik.touched.password && formik.errors.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            size="small"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Qualification</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="qualification"
                                        name="qualification"
                                        type="text"
                                        value={formik.values.qualification}
                                        onChange={formik.handleChange}
                                        error={formik.touched.qualification && Boolean(formik.errors.qualification)}
                                        helperText={formik.touched.qualification && formik.errors.qualification}
                                    />
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Address</span>
                                    <TextField
                                        fullWidth size="small" variant="outlined"
                                        autoComplete="off"
                                        id="address"
                                        name="address"
                                        placeholder="Enter city name"
                                        type="text"
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        error={formik.touched.address && Boolean(formik.errors.address)}
                                        helperText={formik.touched.address && formik.errors.address}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider />

                        <Box className={classes.formSection} style={{ marginTop: 16, marginBottom: 0 }}>
                            <span className={classes.sectionLabel}>Class &amp; Status</span>
                            <Grid container spacing={1} className={classes.formGrid}>
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Class (Optional)</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        error={formik.touched.classId && Boolean(formik.errors.classId)}
                                    >
                                        <Select
                                            id="demo-simple-select"
                                            name="classId"
                                            displayEmpty
                                            value={formik.values.classId || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                formik.setFieldValue('classId', value);
                                                formik.setFieldValue('sectionId', '');
                                                getSectionListByClass(value);
                                            }}
                                        >
                                            <MenuItem value=""><em>Select Class</em></MenuItem>
                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.classId && formik.errors.classId && (
                                            <FormHelperText>{formik.errors.classId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Section (Optional)</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        disabled={!formik.values.classId || sectionList.length === 0}
                                    >
                                        <Select
                                            id="teacher-section-select"
                                            name="sectionId"
                                            displayEmpty
                                            value={formik.values.sectionId || ''}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value=""><em>All Sections</em></MenuItem>
                                            {sectionList.map(({ _id, sectionName }) => (
                                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} className={classes.formGridItem}>
                                    <span className={classes.fieldLabel}>Status</span>
                                    <FormControl
                                        variant="outlined" size="small" fullWidth
                                        error={formik.touched.status && Boolean(formik.errors.status)}
                                    >
                                        <Select
                                            id="demo-simple-select-standard"
                                            name="status"
                                            value={formik.values.status === true || formik.values.status === 'active' ? 'active' : 'inactive'}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value="active">Active</MenuItem>
                                            <MenuItem value="inactive">Inactive</MenuItem>
                                        </Select>
                                        {formik.touched.status && formik.errors.status && (
                                            <FormHelperText>{formik.errors.status}</FormHelperText>
                                        )}
                                    </FormControl>
                                    {(formik.values.status === 'inactive' || formik.values.status === false) && (
                                        <span style={{ color: '#ff9800', fontSize: '0.75rem', marginTop: 6, display: 'block', fontWeight: 500 }}>
                                            ⚠️ Warning: Inactive status will deactivate teacher's login credentials (mobile number and password)
                                        </span>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>

                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn}>
                            {teacher._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={assignOpen}
                onClose={handleAssignClose}
                fullWidth
                maxWidth="md"
                PaperProps={{ className: classes.dialogPaperWide }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        {assignTeacher && hasAdditionalClassAssignments(assignTeacher) ? 'Edit Assign' : 'Assign Class'}
                        {assignTeacher ? ` — ${assignTeacher.teacherName}` : ''}
                    </Typography>
                    <IconButton size="small" onClick={handleAssignClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    <Box className={classes.infoBox}>
                        <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.6 }}>
                            When you assign a class or section to this teacher, they will have <strong>create</strong>, <strong>edit</strong>, <strong>delete</strong>, and <strong>read</strong> access for activities and data in those classes.
                        </Typography>
                    </Box>

                    {assignTeacher?.classId && (
                        <Box className={classes.primaryClassBox}>
                            <Typography variant="caption" style={{ color: '#64748b', fontWeight: 600, display: 'block', marginBottom: 4 }}>
                                Primary class / section
                            </Typography>
                            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                                {assignTeacher.classId?.className || assignTeacher.classId}
                                {assignTeacher.sectionId
                                    ? ` — ${assignTeacher.sectionId?.sectionName || assignTeacher.sectionId}`
                                    : ''}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#64748b', display: 'block', marginTop: 6 }}>
                                You can still assign other sections of this class below.
                            </Typography>
                        </Box>
                    )}

                    <Typography className={classes.sectionLabel}>
                        Additional classes &amp; sections
                    </Typography>
                    <Typography variant="body2" style={{ color: '#64748b', marginBottom: 12 }}>
                        Check other classes, or remaining sections of the primary class, this teacher should also access.
                    </Typography>

                    {assignSectionsLoading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" py={4}>
                            <CircularProgress size={28} style={{ color: '#1769d6' }} />
                        </Box>
                    ) : (
                        <Box className={classes.assignListWrap}>
                            {addClassList.map((cls) => {
                                const classId = String(cls._id);
                                const allSections = assignSectionsByClass[classId] || [];
                                const assignableSections = getAssignableSections(
                                    assignTeacher,
                                    classId,
                                    allSections,
                                );
                                const primaryClassId = getPrimaryClassId(assignTeacher);
                                const primarySectionId = getPrimarySectionId(assignTeacher);
                                const isPrimaryClass = Boolean(primaryClassId) && classId === primaryClassId;
                                const selected = assignSelections[classId] || [];
                                const hasSections = allSections.length > 0;
                                const hasAssignableSections = assignableSections.length > 0;
                                const classChecked = hasAssignableSections
                                    ? isClassFullySelected(classId, assignableSections)
                                    : (!hasSections && assignSelections[classId] !== undefined);
                                const classIndeterminate =
                                    hasAssignableSections
                                    && isClassPartiallySelected(classId, assignableSections);

                                // Primary class with no other sections left — still show it locked.
                                if (isPrimaryClass && hasSections && !hasAssignableSections) {
                                    return (
                                        <Box key={classId} className={classes.assignClassBlock}>
                                            <Typography className={classes.assignClassTitle} style={{ paddingLeft: 8 }}>
                                                {cls.className}
                                                <Typography component="span" variant="caption" style={{ color: '#94a3b8', marginLeft: 8 }}>
                                                    (primary — no other sections)
                                                </Typography>
                                            </Typography>
                                            <Box className={classes.assignSectionRow}>
                                                {allSections.map((sec) => (
                                                    <FormControlLabel
                                                        key={sec._id}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                size="small"
                                                                checked
                                                                disabled
                                                            />
                                                        }
                                                        label={`${sec.sectionName} (primary)`}
                                                    />
                                                ))}
                                            </Box>
                                        </Box>
                                    );
                                }

                                return (
                                    <Box key={classId} className={classes.assignClassBlock}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={classChecked}
                                                    indeterminate={classIndeterminate}
                                                    disabled={isPrimaryClass && !hasAssignableSections && !hasSections}
                                                    onChange={() =>
                                                        toggleAssignClass(
                                                            classId,
                                                            isPrimaryClass ? assignableSections : allSections,
                                                        )
                                                    }
                                                />
                                            }
                                            label={
                                                <Typography className={classes.assignClassTitle}>
                                                    {cls.className}
                                                    {isPrimaryClass ? (
                                                        <Typography component="span" variant="caption" style={{ color: '#64748b', marginLeft: 8 }}>
                                                            (primary class — pick more sections)
                                                        </Typography>
                                                    ) : null}
                                                </Typography>
                                            }
                                        />
                                        {hasSections ? (
                                            <Box className={classes.assignSectionRow}>
                                                {allSections.map((sec) => {
                                                    const sid = String(sec._id);
                                                    const isPrimarySection =
                                                        isPrimaryClass && primarySectionId && sid === primarySectionId;
                                                    return (
                                                        <FormControlLabel
                                                            key={sec._id}
                                                            control={
                                                                <Checkbox
                                                                    color="primary"
                                                                    size="small"
                                                                    checked={
                                                                        isPrimarySection
                                                                            ? true
                                                                            : selected.includes(sid)
                                                                    }
                                                                    disabled={isPrimarySection}
                                                                    onChange={() => {
                                                                        if (isPrimarySection) return;
                                                                        toggleAssignSection(classId, sec._id);
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                isPrimarySection
                                                                    ? `${sec.sectionName} (primary)`
                                                                    : sec.sectionName
                                                            }
                                                        />
                                                    );
                                                })}
                                            </Box>
                                        ) : (
                                            <Typography variant="caption" style={{ color: '#94a3b8', paddingLeft: 32 }}>
                                                No sections — whole class access
                                            </Typography>
                                        )}
                                    </Box>
                                );
                            })}
                            {addClassList.length === 0 && (
                                <Box p={3} textAlign="center">
                                    <Typography variant="body2" color="textSecondary">
                                        No classes available to assign.
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    <Button onClick={handleAssignClose} className={classes.cancelBtn}>Cancel</Button>
                    <Button
                        onClick={handleAssignSave}
                        variant="contained"
                        className={classes.saveBtn}
                        disabled={!assignTeacher}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={transferOpen}
                onClose={handleTransferClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: classes.dialogPaperTransfer }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        Transfer class to another teacher
                    </Typography>
                    <IconButton size="small" onClick={handleTransferClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    <Box className={classes.infoBox}>
                        <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.6 }}>
                            All classes assigned to this teacher (primary and additional) move to the teacher you select, along with related data for those classes.
                            Choose which class should become the destination teacher&apos;s primary class. If they already have a primary class, it is kept under Additional Class &amp; Section.
                        </Typography>
                    </Box>
                    {transferFromTeacher && (
                        <Box className={classes.transferAssignedBox}>
                            <Typography style={{ color: '#46566b', fontSize: '0.9rem', marginBottom: 8 }}>
                                Transferring from <strong>{transferFromTeacher.teacherName}</strong>
                                {' '}({transferAssignedClasses.length} class{transferAssignedClasses.length === 1 ? '' : 'es'}):
                            </Typography>
                            <Box display="flex" flexWrap="wrap" style={{ gap: 4, marginBottom: transferAssignedClasses.length > 1 ? 12 : 0 }}>
                                {transferAssignedClasses.map((cls) => (
                                    <Chip
                                        key={cls.classId}
                                        size="small"
                                        icon={<SchoolIcon style={{ fontSize: 14 }} />}
                                        label={`${cls.className}${cls.sectionName ? ` · ${cls.sectionName}` : ''}${cls.isPrimary ? ' (primary)' : ''}`}
                                        className={classes.transferAssignedChip}
                                    />
                                ))}
                            </Box>
                            {transferAssignedClasses.length > 1 && (
                                <>
                                    <Typography className={classes.sectionLabel} style={{ marginBottom: 8 }}>
                                        New primary class for destination teacher
                                    </Typography>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            value={transferClassId}
                                            onChange={(e) => setTransferClassId(e.target.value)}
                                            displayEmpty
                                        >
                                            {transferAssignedClasses.map((cls) => (
                                                <MenuItem key={cls.classId} value={cls.classId}>
                                                    {cls.className}
                                                    {cls.sectionName ? ` · ${cls.sectionName}` : ''}
                                                    {cls.isPrimary ? ' (current primary)' : ''}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </>
                            )}
                        </Box>
                    )}

                    <Typography className={classes.sectionLabel}>
                        Active teachers ({teachersForTransfer.length})
                        {transferWithoutClassCount > 0
                            ? ` · ${transferWithoutClassCount} without class`
                            : ''}
                    </Typography>

                    {!transferCandidatesLoading && teachersForTransfer.length > 0 && (
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            placeholder="Search by name, class, mobile, or email..."
                            value={transferTeacherSearch}
                            onChange={(e) => setTransferTeacherSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: '#94a3b8', fontSize: 20 }} />
                                    </InputAdornment>
                                ),
                            }}
                            style={{ marginBottom: 12 }}
                        />
                    )}

                    <RadioGroup
                        value={transferToTeacherId}
                        onChange={(e) => setTransferToTeacherId(e.target.value)}
                    >
                        <Box className={classes.transferTeacherList}>
                            {transferCandidatesLoading ? (
                                <Box p={3} textAlign="center">
                                    <CircularProgress size={28} style={{ color: '#1769d6' }} />
                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
                                        Loading teachers...
                                    </Typography>
                                </Box>
                            ) : filteredTeachersForTransfer.length === 0 ? (
                                <Box p={3} textAlign="center">
                                    <Typography variant="body2" color="textSecondary">
                                        {teachersForTransfer.length === 0
                                            ? 'No other active teachers are available. Add or activate a teacher first, then transfer the class to them.'
                                            : 'No teachers match your search.'}
                                    </Typography>
                                </Box>
                            ) : (
                                filteredTeachersForTransfer.map((t) => {
                                    const hasClass = teacherHasPrimaryClass(t);
                                    const className = t.classId?.className || '';
                                    const sectionName = t.sectionId?.sectionName || '';
                                    const classLabel = hasClass
                                        ? `${className || 'Class'}${sectionName ? ` · Sec ${sectionName}` : ''}`
                                        : 'No class assigned';
                                    const transferSectionId = getTransferSectionIdForClass(
                                        transferFromTeacher,
                                        transferClassId,
                                    );
                                    const alreadyHas = teacherAlreadyHasClassSection(
                                        t,
                                        transferClassId,
                                        transferSectionId,
                                    );
                                    return (
                                        <Box
                                            key={t._id}
                                            className={`${classes.transferTeacherRow} ${transferToTeacherId === t._id ? classes.transferTeacherRowSelected : ''}`}
                                            onClick={() => setTransferToTeacherId(t._id)}
                                        >
                                            <FormControlLabel
                                                value={t._id}
                                                control={<Radio color="primary" size="small" />}
                                                label={(
                                                    <Box>
                                                        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                                            <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.9rem' }}>
                                                                {t.teacherName}
                                                            </Typography>
                                                            {!hasClass && (
                                                                <Chip
                                                                    size="small"
                                                                    label="New"
                                                                    style={{
                                                                        height: 20,
                                                                        backgroundColor: '#eef4ff',
                                                                        color: '#1769d6',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.7rem',
                                                                    }}
                                                                />
                                                            )}
                                                            {alreadyHas && (
                                                                <Chip
                                                                    size="small"
                                                                    label="Same class"
                                                                    style={{
                                                                        height: 20,
                                                                        backgroundColor: '#eef4ff',
                                                                        color: '#1769d6',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.7rem',
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>
                                                        <Typography variant="caption" style={{ color: '#64748b', display: 'block' }}>
                                                            {classLabel}
                                                            {(t.mobileNumber || t.email)
                                                                ? ` · ${[t.mobileNumber, t.email].filter(Boolean).join(' · ')}`
                                                                : ''}
                                                        </Typography>
                                                    </Box>
                                                )}
                                                style={{ margin: 0, width: '100%', pointerEvents: 'none' }}
                                            />
                                        </Box>
                                    );
                                })
                            )}
                        </Box>
                    </RadioGroup>
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    <Button onClick={handleTransferClose} className={classes.cancelBtn} disabled={transferSaving}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleTransferSubmit}
                        variant="contained"
                        className={classes.saveBtn}
                        disabled={!transferToTeacherId || !transferClassId || transferSaving}
                        startIcon={transferSaving ? <CircularProgress size={18} color="inherit" /> : <SwapHorizIcon />}
                    >
                        {transferSaving ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={resetPasswordOpen}
                onClose={closeResetPasswordDialog}
                fullWidth
                maxWidth="xs"
                PaperProps={{ className: classes.dialogPaper }}
            >
                <Box className={classes.dialogTitleBar}>
                    <Typography className={classes.dialogTitleText}>
                        Reset Password
                    </Typography>
                    <IconButton size="small" onClick={closeResetPasswordDialog}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.dialogBody}>
                    {resetPasswordSuccess ? (
                        <Box
                            style={{
                                padding: 16,
                                backgroundColor: '#e6f7ed',
                                borderRadius: 10,
                                border: '1px solid #b7e4c7',
                            }}
                        >
                            <Typography variant="body2" style={{ color: '#1a9b54', fontWeight: 600, lineHeight: 1.6 }}>
                                {resetPasswordSuccess}
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            <Box className={classes.infoBox}>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65 }}>
                                    <strong style={{ color: '#0f2d4d' }}>What is Reset Password?</strong>
                                    <br />
                                    It lets the school admin set a new login password for a teacher&apos;s Teacher app account (linked to their mobile number).
                                </Typography>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65, marginTop: 10 }}>
                                    <strong style={{ color: '#0f2d4d' }}>How to use it</strong>
                                    <br />
                                    Enter a new password below (minimum 6 characters) and click Update Password. Share the new password with the teacher securely. They can sign in with their mobile number and this password.
                                </Typography>
                                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.65, marginTop: 10 }}>
                                    <strong style={{ color: '#0f2d4d' }}>Why it is used</strong>
                                    <br />
                                    When a teacher forgets their password, is locked out, or needs credentials restored, you can reset access without removing their account or re-adding them.
                                </Typography>
                            </Box>
                            {resetPasswordTeacher && (
                                <Typography style={{ marginBottom: 16, color: '#46566b', fontSize: '0.9rem' }}>
                                    Set a new login password for <strong>{resetPasswordTeacher.teacherName}</strong>.
                                </Typography>
                            )}
                            <span className={classes.fieldLabel}>New Password</span>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                autoComplete="new-password"
                                type={resetShowPassword ? 'text' : 'password'}
                                value={resetPasswordValue}
                                onChange={(e) => {
                                    setResetPasswordValue(e.target.value);
                                    if (resetPasswordError) setResetPasswordError('');
                                }}
                                error={Boolean(resetPasswordError)}
                                helperText={resetPasswordError || 'Minimum 6 characters'}
                                placeholder="Enter new password"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                size="small"
                                                onClick={() => setResetShowPassword((prev) => !prev)}
                                                edge="end"
                                            >
                                                {resetShowPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogFooter}>
                    {resetPasswordSuccess ? (
                        <Button
                            onClick={closeResetPasswordDialog}
                            variant="contained"
                            className={classes.saveBtn}
                        >
                            Close
                        </Button>
                    ) : (
                        <>
                            <Button onClick={closeResetPasswordDialog} className={classes.cancelBtn}>
                                Cancel
                            </Button>
                            <Button
                                onClick={handleResetPasswordSubmit}
                                variant="contained"
                                className={classes.saveBtn}
                                disabled={!resetPasswordValue.trim() || resetPasswordSaving}
                                startIcon={<VpnKeyIcon />}
                            >
                                {resetPasswordSaving ? 'Updating…' : 'Update Password'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
